import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import EtapaPage from "@/pages/EtapaPage";
import ProfissionaisPage from "@/pages/ProfissionaisPage";
import PerfilProfissionalPage from "@/pages/PerfilProfissionalPage";
import ConteudosPage from "@/pages/ConteudosPage";
import ArtigoPage from "@/pages/ArtigoPage";
import FamiliasPage from "@/pages/FamiliasPage";
import FornecedoresPage from "@/pages/FornecedoresPage";
import PoliticaPage from "@/pages/PoliticaPage";
import AdminPage from "@/pages/AdminPage";
import EntrarPage from "@/pages/EntrarPage";
import MinhaContaPage from "@/pages/MinhaContaPage";
import PainelFornecedorPage from "@/pages/PainelFornecedorPage";
import AuthCallback from "@/pages/AuthCallback";
import NotFoundPage from "@/pages/NotFoundPage";
import CookieConsent from "@/components/CookieConsent";
import { AuthProvider } from "@/context/AuthContext";

function Shell() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    );
  }

  return (
    <>
      <a href="#conteudo-principal" className="skip-link">Pular para o conteúdo</a>
      <ScrollToTop />
      <Header />
      <div id="conteudo-principal">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profissionais" element={<ProfissionaisPage />} />
          <Route path="/profissionais/:id" element={<PerfilProfissionalPage />} />
          <Route path="/conteudos" element={<ConteudosPage />} />
          <Route path="/conteudos/:slug" element={<ArtigoPage />} />
          <Route path="/familias" element={<FamiliasPage />} />
          <Route path="/fornecedores" element={<FornecedoresPage />} />
          <Route path="/entrar" element={<EntrarPage />} />
          <Route path="/minha-conta" element={<MinhaContaPage />} />
          <Route path="/painel-fornecedor" element={<PainelFornecedorPage />} />
          <Route path="/planejamento" element={<EtapaPage />} />
          <Route path="/gestacao" element={<EtapaPage />} />
          <Route path="/parto" element={<EtapaPage />} />
          <Route path="/pos-parto" element={<EtapaPage />} />
          <Route path="/privacidade" element={<PoliticaPage />} />
          <Route path="/termos" element={<PoliticaPage />} />
          <Route path="/politica-editorial" element={<PoliticaPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

function App() {
  const orgJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Maternnia",
    description:
      "Plataforma de acolhimento, conteúdos e profissionais para cada etapa da maternidade.",
    url: typeof window !== "undefined" ? window.location.origin : "",
    logo:
      (typeof window !== "undefined" ? window.location.origin : "") + "/maternnia-logo-dark.png",
  };

  return (
    <div className="App bg-white">
      <MotionConfig reducedMotion="user" transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}>
      <HelmetProvider>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      </Helmet>
      <BrowserRouter>
        <AuthProvider>
          <Shell />
          <CookieConsent />
          <Toaster position="top-center" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
      </HelmetProvider>
      </MotionConfig>
    </div>
  );
}

export default App;
